/**
 * @generated SignedSource<<805817abc7a64d5770deaa1ca52715a9>>
 * @relayHash c4181510476067dbdf5f13ec93c68e70
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c4181510476067dbdf5f13ec93c68e70

import { ConcreteRequest } from 'relay-runtime';
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type insureeDataFromSasisByInsureeNumberQuery$variables = {
  insureeNumber: string;
  nationalInsuranceNumber: number;
};
export type insureeDataFromSasisByInsureeNumberQuery$data = {
  readonly ch_insureeDataFromSasisByInsureeNumber: {
    readonly mapped: {
      readonly address: {
        readonly city: string;
        readonly countryCode: string;
        readonly houseNumberStreet: string;
        readonly postalCode: string;
      };
      readonly dateOfBirth: any;
      readonly firstName: string;
      readonly gatekeeperZsr: string | null;
      readonly gender: Gender;
      readonly healthInsurance: string;
      readonly insuranceCardNumber: string;
      readonly insureeNumber: string;
      readonly isPrimary: boolean;
      readonly lastName: string;
      readonly nationalInsuranceNumber: number;
      readonly socialSecurityNumber: string | null;
      readonly validFrom: any;
      readonly validTo: any;
    } | null;
    readonly rawXml: string | null;
    readonly returnCode: string | null;
    readonly returnMessage: string | null;
  };
};
export type insureeDataFromSasisByInsureeNumberQuery = {
  response: insureeDataFromSasisByInsureeNumberQuery$data;
  variables: insureeDataFromSasisByInsureeNumberQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "insureeNumber"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nationalInsuranceNumber"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "insureeNumber",
        "variableName": "insureeNumber"
      },
      {
        "kind": "Variable",
        "name": "nationalInsuranceNumber",
        "variableName": "nationalInsuranceNumber"
      }
    ],
    "concreteType": "SasisLookupResult",
    "kind": "LinkedField",
    "name": "ch_insureeDataFromSasisByInsureeNumber",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PatientInsuranceCardDetails",
        "kind": "LinkedField",
        "name": "mapped",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOfBirth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gender",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insureeNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insuranceCardNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "socialSecurityNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "healthInsurance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nationalInsuranceNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPrimary",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gatekeeperZsr",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validFrom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validTo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "houseNumberStreet",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rawXml",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "returnCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "returnMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "insureeDataFromSasisByInsureeNumberQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "insureeDataFromSasisByInsureeNumberQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "c4181510476067dbdf5f13ec93c68e70",
    "metadata": {},
    "name": "insureeDataFromSasisByInsureeNumberQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3b5b14cd2bb85297199fbf5c0ee220d0";

export default node;
